import { LeaveTeamFnReq, LeaveTeamFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';

export class LeaveTeamInteractor {
  private readonly leaveTeamFn = httpsCallable<LeaveTeamFnReq, LeaveTeamFnRes>(
    this.functions,
    'leaveTeam',
  );

  constructor(private readonly functions: Functions) {}

  public async execute(): Promise<void> {
    await this.leaveTeamFn();
  }
}
